import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import "./ExpandMenu.scss";

const ExpandMenu = ({ route, toggleDrawer }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <div className="drawerExpandMenu">
        {/* <div className="expandToggleIcon" onClick={toggleMenu}>
          {route.name}{" "}
          {isMenuOpen ? (
            <i className="fa-solid fa-angle-down down_icon"></i>
          ) : (
            <i className="fa-solid fa-angle-right"></i>
          )}
        </div> */}

        <div
          className={
            isMenuOpen ? "expandToggleIcon active" : "expandToggleIcon"
          }
          onClick={toggleMenu}
        >
          {route.name}
          {/* <i className="fa-solid fa-angle-right"></i> */}
          {/* <i className="fa-solid fa-circle-chevron-right"></i> */}
          <i className="fa-solid fa-square-caret-right"></i>
        </div>

        <SubRoutesContent isOpen={isMenuOpen}>
          {route.subRoutes.map((subRoute) => (
            <div className="subRoute" key={subRoute.name}>
              <Link to={subRoute.link} onClick={toggleDrawer}>
                {subRoute.name}
              </Link>
            </div>
          ))}
        </SubRoutesContent>
      </div>
    </>
  );
};

export default ExpandMenu;

const SubRoutesContent = styled.div`
  display: ${(props) => (props.isOpen ? "flex" : "none")};
  flex-direction: column;
  padding: 1rem;
  // background-color: #b92d5d;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-bottom: 15px;
  transition: 0.5s ease !important;
`;
